export interface CreateUserBody {
    organizationId: number;

    userName: string;

    password: string;
}
